// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Section_wrapper__iGzer","content":"Section_content__4gS0c","responsive":"Section_responsive__puLFZ"};